export const getErrorResponseMessage = (error) => {
  let message = error.message;
  console.log(error.response)
  if (error.response && error.response.data.message) {
    message = error.response.data.message;
  }

  return message;
}